import React from 'react';
import'./About.css'
import { Container } from 'react-bootstrap';

const About = () => {
    return (
        <div id='about' className='pt-5'>
            <Container>
                <div className='row'>
            <div className='col-md-10 text-dark ' data-aos="fade-up"
     data-aos-anchor-placement="center-bottom"
     data-aos-duration="1500">
        <h2 className='section__title'>Hi_</h2>
        <p>I am Arman Hosssain, a Junior MERN Stack Web developer able to build a Web presence from the ground up - from concept, navigation, layout and programming to  SEO. Experienced with a demonstrated history of working in the computer software industry. Skilled in Front End technologies such as Html5 , Css3 , JavaScript , React , BootStrap, Material UI,  and Back End technologies such as Node.JS, Express JS and MongoDb. Learning a variety of scripting languages and multimedia tools is one of my strengths. I am also a hard worker and team player. I am looking for a challenging opportunity that will enable me to use my skills and abilities to achieve a challenging goal.</p>
            </div>
            <div className='col-md-2'>

            </div>
                </div>
            </Container>
        </div>
    );
};

export default About;